import React from "react";
import moment from "moment";
import Modal from "react-responsive-modal";
import LoadMask from "Utils/LoadMask/LoadMask";
import Paginacion from "../../../../../Utils/Components/Paginacion/Paginacion";
import { RenderNumberPercentage } from "../../../../../Utils/renderField/renderReadField";
import { formatWithMinDigits } from "../../../../../../../utility/utils";

export const ModalHistorialRepeticiones = ({ historial }) => {
    const {
        modalAbierto,
        solicitud,
        repeticiones,
        paginaSeleccionada,
        setPaginaSeleccionada,
        cantidadResultados,
        CerrarModal,
        cargando,
    } = historial;

    if (!solicitud) {
        return null;
    }

    return (
        <Modal
            open={modalAbierto}
            onClose={CerrarModal}
            closeOnOverlayClick={false}
            focusTrapped={false}
            styles={{
                modal: {
                    maxWidth: "700px",
                    width: "90%",
                },
            }}
        >
            <LoadMask loading={cargando} blur>
                <div className="historial-repeticiones__modal">
                    <h4 className="text-center mb-1">
                        Historial de repeticiones
                    </h4>
                    <p className="text-center mb-3">
                        Solicitud {formatWithMinDigits(solicitud.id)} ·{" "}
                        {solicitud.tipo_display}
                    </p>

                    <div className="new-table-wrapper">
                        <table className="table-striped">
                            <thead>
                                <tr>
                                    <th>Fecha y hora</th>
                                    <th>Usuario</th>
                                    <th>DRC anterior</th>
                                    <th>Motivo</th>
                                </tr>
                            </thead>
                            <tbody>
                                {repeticiones.length === 0 && (
                                    <tr>
                                        <td colSpan={4} className="text-center">
                                            {cargando
                                                ? "Cargando..."
                                                : "No hay repeticiones registradas."}
                                        </td>
                                    </tr>
                                )}
                                {repeticiones.map((repeticion) => (
                                    <tr key={repeticion.id}>
                                        <td className="text-center text-nowrap">
                                            {moment(
                                                repeticion.fecha_creacion,
                                            ).format("DD/MM/YYYY HH:mm")}
                                        </td>
                                        <td className="text-center">
                                            {repeticion.usuario || "—"}
                                        </td>
                                        <td className="text-center text-nowrap">
                                            <RenderNumberPercentage
                                                value={repeticion.drc_anterior}
                                                decimalScale={3}
                                            />
                                        </td>
                                        <td className="historial-repeticiones__motivo">
                                            {repeticion.motivo || "—"}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <Paginacion
                        cantidadResultados={cantidadResultados}
                        paginaSeleccionada={paginaSeleccionada}
                        setPaginaSeleccionada={setPaginaSeleccionada}
                    />

                    <div className="d-flex justify-content-center mb-2">
                        <button
                            type="button"
                            className="btn btn-outline-dark"
                            onClick={CerrarModal}
                        >
                            Regresar
                        </button>
                    </div>
                </div>
            </LoadMask>
        </Modal>
    );
};
